"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamoDbBaseEntity = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const uuid = __importStar(require("uuid"));
const dynamodb_data_types_1 = require("dynamodb-data-types");
class DynamoDbBaseEntity {
    constructor() {
        this.id = uuid.v4();
        this.createdAt = (0, dayjs_1.default)().format('YYYY-MM-DD HH:mm:ss');
        this.updatedAt = (0, dayjs_1.default)().format('YYYY-MM-DD HH:mm:ss');
    }
    batchWritePutRequest() {
        return {
            PutRequest: {
                Item: dynamodb_data_types_1.AttributeValue.wrap(this),
            },
        };
    }
    putItem() {
        return dynamodb_data_types_1.AttributeValue.wrap(this);
    }
    static batchDeleteRequestList(result) {
        return result.Items.map((item) => {
            return {
                DeleteRequest: {
                    Key: {
                        PK: item.PK,
                        SK: item.SK,
                    },
                },
            };
        });
    }
    static getItems(result) {
        return result.Items.map((item) => dynamodb_data_types_1.AttributeValue.unwrap(item));
    }
    static getItem(result) {
        return dynamodb_data_types_1.AttributeValue.unwrap(result.Item);
    }
    static getUpdateItem(result) {
        return dynamodb_data_types_1.AttributeValue.unwrap(result.Attributes);
    }
    static getBatchWritePutRequest(item) {
        return {
            PutRequest: {
                Item: dynamodb_data_types_1.AttributeValue.wrap(item),
            },
        };
    }
}
exports.DynamoDbBaseEntity = DynamoDbBaseEntity;
